/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_5_HInputs */

const en_privacy_5_h = /** @type {(inputs: Privacy_5_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies and analytics`)
};

const id_privacy_5_h = /** @type {(inputs: Privacy_5_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie dan analitik`)
};

/**
* | output |
* | --- |
* | "Cookies and analytics" |
*
* @param {Privacy_5_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_5_h = /** @type {((inputs?: Privacy_5_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_5_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_5_h(inputs)
	return en_privacy_5_h(inputs)
});